//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const title = 'Preliminary report'
    const description = 'California is a state in the western United States'
    const rules = [v => v.length <= 25 || 'Max 25 characters']

    return {
      title,
      description,
      rules,
    }
  },
}
